"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _moment = _interopRequireDefault(require("moment"));

var _dateformart = require("@/utils/dateformart");

var _SummaryPopup = _interopRequireDefault(require("@/components/SummaryPopup"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: 'amountChangeRecord:view',
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default,
    SummaryPopup: _SummaryPopup.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['auditOptions', 'informationOptions', 'orderStateOption', 'amountChangeReasonOption', 'userTypeOption'])),
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      agentOption: [],
      organizationOption: [],
      total: 0,
      listLoading: true,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        timeList: [],
        agentId: '',
        organizationCode: '',
        orderNo: '',
        amountChangeReason: '',
        accountType: ''
      },
      multipleSelection: [],
      viewSummary: false,
      summaryList: []
    };
  },
  created: function created() {
    this.setDefaultTime();
    this.getOption();
    this.getList();
  },
  methods: {
    setDefaultTime: function setDefaultTime() {
      var a = new Date(Date.now());
      a.setHours(0, 0, 0, 0);
      var b = new Date(Date.now());
      b.setHours(23, 59, 59, 0);
      this.queryParameter.timeList = [this.dateFormat(a), this.dateFormat(b)];
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      var params = this.getQueryParams();

      _httpUtils.default.post("agentAmountChangeRecord", "list", null, params).then(function (res) {
        //let index;
        _this.viewSummary = false;
        _this.summaryList = [];
        _this.list = res.data.rows;
        _this.total = res.data.total;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    getOption: function getOption() {
      var _this2 = this;

      if (this.$store.getters.isAdmin) {
        _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
          _this2.agentOption = agent.data;
        }).catch(function (err) {
          _this2.$notify({
            title: _this2.$t("common.error"),
            message: _this2.$t("common.fetchError") + ',' + err.message,
            type: "error"
          });
        });
      }
    },
    getQueryParams: function getQueryParams() {
      var createStartTime, createEndTime, state;

      if (!this.queryParameter.timeList) {
        createStartTime = (0, _dateformart.getYesterday)();
        createEndTime = (0, _dateformart.getYesterdayEnd)();
      } else {
        createStartTime = this.queryParameter.timeList[0];
        createEndTime = this.queryParameter.timeList[1];
      }

      if (this.queryParameter.state !== null) {
        state = this.queryParameter.state;
      }

      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        createStartTime: createStartTime,
        createEndTime: createEndTime,
        state: state,
        orderNo: this.queryParameter.orderNo,
        agentId: this.queryParameter.agentId,
        organizationCode: this.queryParameter.organizationCode,
        amountChangeReason: this.queryParameter.amountChangeReason,
        accountType: this.queryParameter.accountType
      };
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleExportReport: function handleExportReport() {
      var excelName = _lang.default.t("route.agentAmountChangeRecordReport") + ".xlsx";
      var params = this.getQueryParams(); // httpUtils.getByBlob("statisticalChannel", "excel", params, excelName);

      _httpUtils.default.getByBlob("agentAmountChangeRecord", "excel", params, excelName); // MessageBox.confirm(
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateMessage"),
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateTitle"),
      //   {
      //     confirmButtonText: i18n.t("warningMessage.exportAndNavigateConfirmButtonText"),
      //     cancelButtonText: i18n.t("warningMessage.exportAndNavigateCancelButtonText"),
      //     type: 'warning'
      //   }
      // ).then(() => {
      //   // route to exported excel page
      //   this.$router.push({
      //     name: "exportedExcel:view"
      //   });
      // }).catch(() => null);

    },
    getStatistic: function getStatistic() {
      var _this3 = this;

      var params = this.getQueryParams();

      _httpUtils.default.post("agentAmountChangeRecord", "sum", null, params).then(function (res) {
        var data = res.data;
        _this3.summaryList = [[{
          label: 'agentAmountChangeRecord.effectiveAmountBeforeOperation',
          value: data.processInitAvailableAmount || 0,
          unit: 'USD'
        }, {
          label: 'agentAmountChangeRecord.changeEffectiveAmount',
          value: data.processChangeAvailableAmount || 0,
          unit: 'USD'
        }, {
          label: 'agentAmountChangeRecord.effectiveAmountAfterOperation',
          value: data.processFinalAvailableAmount || 0,
          unit: 'USD'
        }, {
          label: 'agentAmountChangeRecord.amountToBeCreditedBeforeOperation',
          value: data.processInitUncreditedAmount || 0,
          unit: 'USD'
        }, {
          label: 'agentAmountChangeRecord.changesToTheAmountToBeRecorded',
          value: data.processChangeUncreditedAmount || 0,
          unit: 'USD'
        }, {
          label: 'agentAmountChangeRecord.amountToBeCreditedAfterOperation',
          value: data.processFinalUncreditedAmount || 0,
          unit: 'USD'
        }]];
      }).catch(function (err) {
        _this3.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }).finally(function () {
        if (_this3.viewSummary == true) {
          _this3.viewSummary = false;
        } else {
          _this3.viewSummary = true;
        }
      });
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined || date == '-') {
        return "-";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    convertAgentNameByAgentId: function convertAgentNameByAgentId(id) {
      if (!this.agentOption || !this.agentOption.length) return;
      var found = this.agentOption.find(function (agent) {
        return agent.agentId === id;
      });

      if (found) {
        return found.agentName;
      } else {
        return id;
      }
    },
    convertOrganizationNameByOrganizationCode: function convertOrganizationNameByOrganizationCode(organizationCode) {
      if (!this.organizationOption || !this.organizationOption.length) return;
      var found = this.organizationOption.find(function (organization) {
        return organization.organizationCode === organizationCode;
      });

      if (found) {
        return found.organizationName;
      } else {
        return organizationCode;
      }
    },
    convertAmountChangeReasonOptionByKey: function convertAmountChangeReasonOptionByKey(key) {
      if (!this.amountChangeReasonOption || !this.amountChangeReasonOption.length) return;
      var found = this.amountChangeReasonOption.find(function (amountChangeReason) {
        return amountChangeReason.key === key;
      });

      if (found) {
        return found.display_name;
      } else {
        return key;
      }
    }
  }
};
exports.default = _default;